import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLine, Reveal } from "@/components/Reveal";
import CTABand from "@/components/CTABand";
import { SERVICES } from "@/data/site";

export default function ServicesIndex() {
  useEffect(() => {
    document.title = "Services — LEDOS Enterprise Solutions";
  }, []);

  return (
    <main data-testid="services-index-page">
      <section className="relative bg-ink pt-44 pb-20 md:pb-28 overflow-hidden">
        <div aria-hidden="true" className="absolute inset-0 grid-bg" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <MaskedLine delay={0.1}>
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-signal mb-8">
              Services
            </p>
          </MaskedLine>
          <h1 className="font-display font-black tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-7xl max-w-4xl">
            <MaskedLine delay={0.25}>Everything between</MaskedLine>
            <MaskedLine delay={0.38}>
              <span>
                the wall and <span className="text-signal">the workspace.</span>
              </span>
            </MaskedLine>
          </h1>
          <Reveal delay={0.5} className="mt-10 max-w-2xl">
            <p className="text-base md:text-lg leading-relaxed text-zinc-400">
              From networks, servers and structured cabling to ATMs, POS systems, surveillance
              and digital signage — LEDOS deploys and maintains the technology that powers
              business operations.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ink pb-24 md:pb-36">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="border-t border-line">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={i * 0.04}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`services-index-row-${s.slug}`}
                  className="group grid md:grid-cols-12 gap-4 md:gap-8 items-center py-10 md:py-14 border-b border-line px-2 md:px-6 hover:bg-panel transition-colors duration-500"
                >
                  <span className="md:col-span-1 font-display text-4xl md:text-5xl font-black tracking-tighter text-outline-signal">
                    {s.num}
                  </span>
                  <h2 className="md:col-span-5 font-display text-2xl md:text-4xl font-bold tracking-tight text-white group-hover:text-signal transition-colors duration-500">
                    {s.title}
                  </h2>
                  <p className="md:col-span-5 text-sm md:text-base leading-relaxed text-zinc-500">
                    {s.short}
                  </p>
                  <span className="md:col-span-1 flex md:justify-end">
                    <span className="inline-flex items-center justify-center w-12 h-12 border border-line group-hover:border-signal group-hover:bg-signal group-hover:text-black text-zinc-500 transition-colors duration-500">
                      <ArrowUpRight className="w-5 h-5" />
                    </span>
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </main>
  );
}
